import { AlertItem } from "../pages/Alerts/alertsMockData";
import { fetchDataV2, postDataV2 } from "./utils";

// Live now (docs/needed-endpoints.md §8, confirmed against real GET/POST responses) - the previous
// mock kept a filter for "state !== dismissed" on the client side; the real GET responses are
// documented as already excluding dismissed (and, per alertsMockData.ts's own comment, presumably
// snoozed) alerts server-side, but the client-side filter stays as a harmless safety net either
// way, matching this session's convention elsewhere (e.g. dashboardAccessRequestsApi.ts).
const isVisible = (alert: AlertItem): boolean => alert.state !== "dismissed" && alert.state !== "snoozed";

export const getAlerts = (): Promise<AlertItem[]> =>
  fetchDataV2("/alerts").then((response) => (Array.isArray(response) ? response.filter(isVisible) : []));

export const getAlertsForDashboard = (dashboardId: number): Promise<AlertItem[]> =>
  fetchDataV2(`/alerts/dashboard/${dashboardId}`).then((response) => (Array.isArray(response) ? response.filter(isVisible) : []));

// Unlike getAlerts/getAlertsForDashboard above, these two are already exactly the caller's own
// snoozed/dismissed alerts - no client-side isVisible filter to apply (that would just filter
// everything back out again).
export const getSnoozedAlerts = (): Promise<AlertItem[]> =>
  fetchDataV2("/alerts/snoozed").then((response) => (Array.isArray(response) ? response : []));

export const getDismissedAlerts = (): Promise<AlertItem[]> =>
  fetchDataV2("/alerts/dismissed").then((response) => (Array.isArray(response) ? response : []));

export interface AlertDismissResponse {
  alert_id: string;
  state: AlertItem["state"];
}

export const dismissAlert = (alertId: string): Promise<AlertDismissResponse> => postDataV2(`/alerts/${alertId}/dismiss`, {});

export interface AlertSnoozeResponse {
  alert_id: string;
  state: AlertItem["state"];
  snoozed_until: string;
}

export const snoozeAlert = (alertId: string, snoozedUntil: string): Promise<AlertSnoozeResponse> =>
  postDataV2(`/alerts/${alertId}/snooze`, { snoozed_until: snoozedUntil });

export interface AlertClearedResponse {
  alert_id: string;
  state: null;
}

export const unsnoozeAlert = (alertId: string): Promise<AlertClearedResponse> => postDataV2(`/alerts/${alertId}/unsnooze`, {});

export const undismissAlert = (alertId: string): Promise<AlertClearedResponse> => postDataV2(`/alerts/${alertId}/undismiss`, {});
